import functions from "./functions";

let faqLinks, faqSections, faqJumpList;

function init() {
    if (functions.checkPage('page-faq')) {

        faqLinks = document.querySelectorAll('[data-faq-link]');
        faqSections = document.querySelectorAll('[data-faq-section]');
        faqJumpList = document.querySelectorAll('[data-faq-jump]');

        if (window.innerWidth > functions.breakpoints.sm) {
            faqJump();
        }

        window.addEventListener('scroll', () => {
            faqHighlight(scrollY);
        });

    }
}

function faqHighlight(scrollY) {
    let currentSectionID = '';

    if (faqSections) {
        faqSections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.clientHeight;

            if (scrollY >= (sectionTop - sectionHeight / 10)) {
                currentSectionID = section.getAttribute('id');
            }
        });
    }

    if (faqLinks) {
        faqLinks.forEach(link => {
            link.classList.remove('active');

            let linkHref = link.getAttribute('href').slice(1);

            if (linkHref === currentSectionID) {
                link.classList.add('active');
            }
        });
    }
}

function faqJump() {
    if (faqJumpList) {
        faqJumpList.forEach(item => {
            const hashValue = item.getAttribute('href');

            if (hashValue) {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    functions.windowScroll(hashValue);
                });
            }
        });
    }
}

export default {init};


// WEBPACK FOOTER //
// ./src/scripts/faq-page.js